module.exports = __webpack_public_path__ + "static/media/chat.4d3b63b7.svg";